// Styles
import '../styles/variables.css';
import '../styles/base.css';
import '../styles/layout.css';
import '../styles/components.css';
import '../styles/views.css';
import '../styles/responsive.css';
import '../styles/animations.css';
import '../styles/context.css';
import '../styles/terminal.css';
import '../styles/avi.css';
import '../styles/avi-podcast.css';
import '../styles/skills.css';
import '../styles/observer-mcp.css';
import '../styles/integrations.css';

// Core Modules
import './app';
import './auth';
import './context-engine';
import './ide-engine';
import './observer-mcp';
import './integrations';

// Component Modules
import '../components/ai-helper';
import '../components/ai-tools';
import '../components/avi';
import '../components/interactive-avi';
import '../components/avi-podcast';

// Services & Bridges
import '../services/antigravity-bridge';

console.log('AI Tools Modular Architecture Initialized');
